import { Icon, type IconName } from './Icon';

interface StatusConfig {
  className: string;
  icon: IconName;
  label: string;
}

const STATUS_CONFIG_MAP: Record<string, StatusConfig> = {
  // Employment & General
  active: { className: 'badge badge-active', icon: 'checkCircle', label: 'Active' },
  verified: { className: 'badge badge-verified', icon: 'checkCircle', label: 'Verified' },
  probation: { className: 'badge badge-probation', icon: 'clockCircle', label: 'Probation' },
  notice: { className: 'badge badge-probation', icon: 'alertTriangle', label: 'On Notice' },
  exited: { className: 'badge badge-exited', icon: 'userX', label: 'Exited' },
  terminated: { className: 'badge badge-exited', icon: 'userX', label: 'Terminated' },

  // Workflows & Approvals
  draft: { className: 'badge badge-draft', icon: 'fileText', label: 'Draft' },
  pending: { className: 'badge badge-pending', icon: 'clockCircle', label: 'Pending' },
  submitted: { className: 'badge badge-submitted', icon: 'send', label: 'Submitted' },
  reviewed: { className: 'badge badge-pending', icon: 'eye', label: 'Reviewed' },
  approved: { className: 'badge badge-approved', icon: 'checkCircle', label: 'Approved' },
  published: { className: 'badge badge-published', icon: 'checkCircle', label: 'Published' },
  finalized: { className: 'badge badge-approved', icon: 'shieldCheck', label: 'Finalized' },
  rejected: { className: 'badge badge-rejected', icon: 'xCircle', label: 'Rejected' },
  cancelled: { className: 'badge badge-rejected', icon: 'xCircle', label: 'Cancelled' },

  // Financial
  paid: { className: 'badge badge-paid', icon: 'checkCircle', label: 'Paid' },
  cleared: { className: 'badge badge-cleared', icon: 'checkCircle', label: 'Cleared' },
  unpaid: { className: 'badge badge-pending', icon: 'clockCircle', label: 'Unpaid' },
  partial: { className: 'badge badge-pending', icon: 'coins', label: 'Partially Paid' },
  partially_paid: { className: 'badge badge-pending', icon: 'coins', label: 'Partially Paid' },
  overdue: { className: 'badge badge-overdue', icon: 'alertCircle', label: 'Overdue' },
  issued: { className: 'badge badge-issued', icon: 'invoice', label: 'Issued' },
};

export function StatusBadge({
  status,
  label,
  showIcon = true,
}: {
  status: string;
  label?: string;
  showIcon?: boolean;
}) {
  const normalized = (status || '').toLowerCase().trim();
  const config = STATUS_CONFIG_MAP[normalized] ?? {
    className: 'badge badge-neutral',
    icon: 'infoCircle',
    label: status || 'Unknown',
  };

  const displayText = label || config.label;

  return (
    <span className={config.className}>
      {showIcon && <Icon name={config.icon} size="xs" />}
      <span>{displayText}</span>
    </span>
  );
}
